import { render, staticRenderFns } from "./ConceptSearchBox.vue?vue&type=template&id=127433e0&scoped=true"
import script from "./ConceptSearchBox.vue?vue&type=script&lang=ts"
export * from "./ConceptSearchBox.vue?vue&type=script&lang=ts"
import style0 from "./ConceptSearchBox.vue?vue&type=style&index=0&id=127433e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127433e0",
  null
  
)

export default component.exports